import React from 'react'
import AboutNavBar from '../components/AboutNavBar'
// import BlockChainServiceDetails from '../components/BlockChainServiceDetails'
// import BlockChainServicesContent from '../components/BlockChainServicesContent'
import Blog1Details from '../components/Blog1Details'
import Footer from '../components/Footer'
import RenderLinks from '../components/RenderLinks'

function Blog1() {
  return (
    <div>
      {/* <RenderLinks/> */}
      <AboutNavBar/>
      <Blog1Details/>
      {/* <BlockChainServiceDetails/> */}
      {/* <BlockChainServicesContent/> */}
      <Footer/>
    </div>
  )
}

export default Blog1
